export const DimensionNames = {
  PostingDate: "PostingDate",
  TransactionDate: "TransactionDate",
  AccountingBook: "AccountingBook",
  AccountCategory: "AccountCategory",
  AccountSubcategory: "AccountSubcategory",
  AccountName: "AccountName",
  AccountNo: "AccountNo",
};

export const isAccountBasedField = (field: string) => {
  return (
    field === DimensionNames.AccountNo ||
    field === DimensionNames.AccountName ||
    field === DimensionNames.AccountCategory ||
    field === DimensionNames.AccountSubcategory
  );
};

export const DataSetIds = {
  GeneralAndMemo: "GeneralAndMemo",
  PortfolioMonitoring: "PortfolioMonitoring",
};
